import { defaults } from 'lodash';
const options = [
  {
    'key': 'organization',
    'val': 'only organization',
    onlyOrganizations: true,
  },
  {
    'key': 'place',
    'val': 'only place',
    onlyPlace: true,
  },
  {
    'key': 'placeAndLines',
    'val': 'place and lines',
    placeLines: true,
  },
  {
    'key': 'all',
    'val': 'all the places',
    all: true,
  },
  {
    'key': 'orgPlacesLines',
    'val': 'all the places and lines',
    orgPlacesLines: true,
  }
];

const generateOptions = () =>
  defaults(
    { options: options.filter((o) => o.onlyOrganizations || o.all) },
    { selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key },
  );

module.exports = {
  options,
  generateOptions,
};
